export const serverApiUrl = '/api';